import { useState } from "react";
import { Modal, FormField, Input, Button } from "../ui/index";
import PhoneInput from "../ui/PhoneInput";

const roles = ["Chef de Projet", "Technicien IoT", "Responsable Technique", "Chef de Chantier"];
const selectStyle = "w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm text-slate-700 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500";

const defaultPermissions = {
  "Chef de Projet":         { creerProjet: true, creerChantier: true, creerNoeud: false, confirmerChantier: true, configIoT: false },
  "Responsable Technique":  { creerProjet: false, creerChantier: true, creerNoeud: true, confirmerChantier: true, configIoT: true },
  "Technicien IoT":         { creerProjet: false, creerChantier: false, creerNoeud: false, confirmerChantier: false, configIoT: true },
  "Chef de Chantier":       { creerProjet: false, creerChantier: false, creerNoeud: false, confirmerChantier: false, configIoT: false },
};

const permissionLabels = {
  creerProjet: "Créer des projets",
  creerChantier: "Créer des chantiers",
  creerNoeud: "Créer des nœuds",
  confirmerChantier: "Confirmer les chantiers terminés",
  configIoT: "Configuration IoT (événements, fonctions, automatisations)",
};

const emptyForm = {
  nom: "", role: "Chef de Projet", email: "", telephone: "",
  statut: "Actif",
  permissions: { ...defaultPermissions["Chef de Projet"] },
};

export default function AddMembreModal({ isOpen, onClose, onAdd }) {
  const [form, setForm] = useState({ ...emptyForm });

  const handleChange = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleRoleChange = (e) => {
    const role = e.target.value;
    setForm(f => ({ ...f, role, permissions: { ...defaultPermissions[role] } }));
  };

  const handlePermToggle = (perm) => () => {
    setForm(f => ({ ...f, permissions: { ...f.permissions, [perm]: !f.permissions[perm] } }));
  };

  const handleSubmit = () => {
    if (!form.nom || !form.email) return;
    onAdd?.(form);
    setForm({ ...emptyForm });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Ajouter un membre" subtitle="Ajoutez un nouveau membre à l'équipe.">
      <div className="space-y-4">

        <FormField label="Nom complet" required>
          <Input value={form.nom} onChange={handleChange("nom")} placeholder="Nom complet" />
        </FormField>

        <FormField label="Rôle">
          <select value={form.role} onChange={handleRoleChange} className={selectStyle}>
            {roles.map(r => <option key={r}>{r}</option>)}
          </select>
        </FormField>

        <FormField label="Email" required>
          <Input value={form.email} onChange={handleChange("email")} placeholder="exemple@gmail.com" type="email" />
        </FormField>

        <FormField label="Téléphone">
          <PhoneInput value={[form.telephone]} onChange={(arr) => setForm(f => ({ ...f, telephone: arr[0] || "" }))} multiple={false} />
        </FormField>

        <FormField label="Statut">
          <select value={form.statut} onChange={handleChange("statut")} className={selectStyle}>
            <option>Actif</option>
            <option>Inactif</option>
          </select>
        </FormField>

        {/* Permissions */}
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Permissions</label>
          <div className="space-y-2 bg-gray-50 rounded-xl p-3 border border-gray-200">
            {Object.entries(permissionLabels).map(([key, label]) => (
              <label key={key} className="flex items-center gap-3 cursor-pointer hover:bg-white rounded-lg px-2 py-1.5 transition-colors">
                <input
                  type="checkbox"
                  checked={form.permissions[key] || false}
                  onChange={handlePermToggle(key)}
                  className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                <span className="text-sm text-slate-700">{label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-2">
          <Button variant="secondary" onClick={onClose}>Annuler</Button>
          <Button onClick={handleSubmit}>Ajouter</Button>
        </div>
      </div>
    </Modal>
  );
}
